import apiClient from './index.js'
let api = apiClient.api();
export default {
    login(params) {
      return api.post("/login",params); 
    },
};